import { Select, MenuItem, FormControl, InputLabel, useTheme } from '@mui/material';

interface IProps {
	options: any;
	selected: any;
	label?: string;
	handleChange: any;
	styleObj?: any;
}

export const SelectList = ({ options, selected, label, handleChange, styleObj }: IProps) => {
	const theme = useTheme();

	return (
		<FormControl
			sx={{
				width: 'fit-content',
				'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
					border: `1px solid ${theme.palette.root.inputFocusGreen}`,
				},
				...styleObj,
			}}
		>
			<InputLabel id="simple-select-label">{label}</InputLabel>
			<Select
				labelId="simple-select-label"
				id="simple-select"
				value={selected?.value}
				onChange={handleChange}
				label={label}
				name={selected?.name || options[0]?.name}
				sx={{
					borderRadius: '4px',
					...styleObj,
				}}
			>
				{options?.map((option: any, index: number) => {
					return (
						<MenuItem
							disabled={option.disabled}
							key={index}
							value={option?.value}
							sx={{ direction: 'ltr' }}
						>
							{option?.name || ''}
						</MenuItem>
					);
				})}
			</Select>
		</FormControl>
	);
};
